// import {hubConnection} from "signalr-no-jquery";
import {
	ARBOL,
	REFRESH_IDCONNECTION,
	DATA_GENERAL,
	LISTAR_POR_PERIODO,
	PROJECT_DETAILS,
	LIST_HISTORY,
	PARTY_CONTROL,
	MENSUAL_DETALLE,
	PROJECT_LIST_DETAILS,
	CLASSIFICATION_DATA,
	TREE_DE,
	TREE_FT, 
	MEANS_TABLE,
	MEANS_DATA,
	COINS,
	TREE_DATA_TAB_3,
	MONTH_RESOURCES,
} from "../constants";

import $ from 'jquery';
window.jQuery = $;
require('signalr');

export const connectSignalr = (token) => {
	return (dispatch) => {
		
		var options = {
			qs: {
				AuthType: 1,
				Token: token,
				ModuleId: process.env.REACT_APP_MODULE_ID,
			}
		};
		const connection = $.hubConnection(process.env.REACT_APP_SIGNALR_URL, options);
		const hubProxy = connection.createHubProxy(process.env.REACT_APP_SIGNALR_PROXY);

		hubProxy.on(process.env.REACT_APP_SIGNALR_RECEIVE, function (response) {
			const data = JSON.parse(response);
			
			switch (data.Name) {
				case ARBOL:
					console.log(JSON.parse(data.Data))
						dispatch({
							type: ARBOL,
							payload: {
								part: data.Part,
								data: JSON.parse(data.Data),
								count: data.Count
							},
						});
					break;
				case DATA_GENERAL:
					
					dispatch({ 
						type: DATA_GENERAL,
						payload: JSON.parse(data.Data),
					});
					break;

				case LISTAR_POR_PERIODO:
					dispatch({
						type: LISTAR_POR_PERIODO,
						payload: JSON.parse(data.Data),
					});
					break;

				case PROJECT_DETAILS:
					dispatch({
						type: PROJECT_DETAILS,
						payload: JSON.parse(data.Data),
					});
				break;

				case MEANS_TABLE:
					
					dispatch({
						type: MEANS_TABLE,
						payload: JSON.parse(data.Data),
					});
				break;
				
				case TREE_DE:
					dispatch({
						type: TREE_DE,
						payload: {
							part: data.Part,
							data: JSON.parse(data.Data),
							count: data.Count
						},
					});
				break;

				case TREE_FT:
					dispatch({
						type: TREE_FT,
						payload: {
							part: data.Part,
							data: JSON.parse(data.Data),
							count: data.Count
						},
					});
				break;
				
				case PARTY_CONTROL:
					dispatch({
						type: PARTY_CONTROL,
						payload: {
							part: data.Part,
							data: JSON.parse(data.Data),
							count: data.Count
						},
					});
					break;
				
				case MENSUAL_DETALLE:
					dispatch({
						type: MENSUAL_DETALLE,
						payload: JSON.parse(data.Data),
					});
					break;	
				
				case PROJECT_LIST_DETAILS:
					dispatch({
						type: PROJECT_LIST_DETAILS,
						payload: JSON.parse(data.Data),
					});
					break;	
				case LIST_HISTORY:
						dispatch({
							type: LIST_HISTORY,
							payload: JSON.parse(data.Data),
						});
					break;
				case CLASSIFICATION_DATA:
					dispatch({
						type: CLASSIFICATION_DATA,
						payload: {
							part: data.Part,
							data: JSON.parse(data.Data),
							count: data.Count
						},
					});
					break;
				case TREE_DATA_TAB_3:
					dispatch({
						type: TREE_DATA_TAB_3,
						payload: {
							part: data.Part,
							data: JSON.parse(data.Data),
							count: data.Count
						},
					})			
					break;
				case MEANS_DATA:
					dispatch({
						type: MEANS_DATA,
						payload: JSON.parse(data.Data)
					})			
					break;

				case COINS:
					dispatch({
						type: COINS,
						payload: JSON.parse(data.Data)
					})			
					break;
				case MONTH_RESOURCES:
					dispatch({
						type: data.Name,
						payload: {
							items: JSON.parse(data.Data),
							totalItems: Number(data.OutputValue?.split('/')[1] || '0')
						},
					})		
					break;
				default:
					dispatch({
						type: data.Name,
						payload: {
							...data,
							data: JSON.parse(data.Data),
							count: data.Count,
							part: data.Part,
						},
					})		
					break;
			}
		});
		// connect
		connection
			.start()
			.done(function () {
				console.log("Now connected, connection ID=" + connection.id);
				localStorage.setItem("connectionId", connection.id);
				dispatch({
					type: REFRESH_IDCONNECTION,
					payload: true
				});
			})
			.fail(function () {
				console.log("Could not connect");
				// alert("Conexion fallida, posiblemente token vencido");
				dispatch({
					type: REFRESH_IDCONNECTION,
					payload: false
				});
			});
	};
};

export const refreshConnection = (token) => {
	return (dispatch) => { 
		var companyLocal = token ? token : JSON.parse(localStorage.getItem("company-s10"));
		if (companyLocal) {
			dispatch(connectSignalr(companyLocal.Token))
		}else{
			dispatch(connectSignalr('error!!'))
		}
	};
};
